export const HausratRoutes = {
  formular: '/formular',
  rechner: '/rechner',
  vergleich: '/vergleich',
  tarifdetailsLaden: '/tarifdetails-laden',
  tarifdetails: '/tarifdetails/:vorgangId',
  step: (n: number) => `/formular/step${n}`,
} as const;
